import dayjs from 'dayjs';
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { PageMode } from '@/main/utils/pageMode';

import { NAME as name, CRUMB_LABEL_KEY, RozsahDate } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const dropdownList = {
	Sklad: [],
	Ndpohyb: [],
	Dodavatel: [],
	SmVaria: [],
	VyrobekndOzn: [],
	VyrobekvozOzn: [],
	ZakazkaDruh: [],
	SkladMisto: [],
	DealerKVPSList: [],
	ZbozidruhOzn: [],
};
export const props = {
	mode: null as PageMode | null,
	filter: {
	},
	afterRowSelection: () => {},
};
export const localState = {
	accessFlags: 0,
	AndOrList: [] as { Text: string, Value: Boolean }[],
	RozsahDateList: [] as { Text: string, Value: RozsahDate }[],
	EnabledObratkovost: false as boolean,
};

export const edit = {
	SmVariaZkt: [],
	AndOr: false,
	DetailTisk: false,
	DatOd: null as Date | null,
	DatDo: null as Date | null,
	RozsahDate: RozsahDate.casLibObdobi,
	ZakazkaNr: null as number | null,
	SkladOzn: null as number | null,
	SkladMistoId: null as number | null,
	NdpohybPzn: null as number | null,
	DodavatelId: null as number | null,
	OrderByDodavatel: false,
	ZmenaMan: true,
	VyrobekndOzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	RozlVV: false,
	ZakazkaDruh: null as string | null,
	DokladPfx: null as string | null,
	DokladPfxPodretezec: false,
	DokladNrOd: null as number | null,
	DokladNrDo: null as number | null,
	ZakazkaNrDo: null as number | null,
	ZakazkaNrOd: null as number | null,
	ND_NR: null as string | null,
	OldestStockAge: null as number | null,
	ObratkovostDatOd: null as Date | string | null,
	ObratkovostDatDo: null as Date | string | null,
	DealerId: null as string[] | null,
	LocationId: null as string[] | null,
	NewStockAge: null as number | null,
	PartCatagoryId: null as number | null,
	AvgStockAge: null as number | null,
	PartDescription: null as string | null,
	NoOfUnitsAvaVal: null as number | null,
	LastOrderedDate: null as Date | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	filter: edit,
	tableSetting: {},
	localState,
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		setRozsahDate(state, rozsah: RozsahDate) {
			state.filter.RozsahDate = rozsah;
			const start = dayjs().startOf('day');
			const kvartal = (start.month() - 1) / 3;

			switch (rozsah) {
				case RozsahDate.casDnes:
					state.filter.DatOd = start.toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casVcera:
					state.filter.DatOd = start.add(-1, 'day').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('day').toDate();
					break;
				case RozsahDate.casTentoMesic:
					state.filter.DatOd = start.startOf('month').toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casMinulyMesic:
					state.filter.DatOd = start.startOf('month').add(-1, 'month').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('month').toDate();
					break;
				case RozsahDate.casTentoRok:
					state.filter.DatOd = start.startOf('year').toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casMinulyRok:
					state.filter.DatOd = start.startOf('year').add(-1, 'year').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('year').toDate();
					break;
				case RozsahDate.casMinulyKvart:
					state.filter.DatOd = start.startOf('year').add(((kvartal - 1) * 3), 'month').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).add(2, 'month').endOf('month').endOf('day')
						.toDate();
					break;
				default:
			}
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => { },
	},
});
